import type { ClassNameProps } from "@msuite/ui/types";
import { cn } from "@msuite/ui/utils";
import type { Nullable, WikiPageTreeItemWithChildren } from "@msuite/utils/types";
import { WikiPageTreeItem } from "./wiki-page-tree-item";

/** Props Interface */
interface WikiPageTreeProps extends ClassNameProps {
	spaceId: string;
	pages: Array<WikiPageTreeItemWithChildren>;
	activePageId: Nullable<string>;
}

/**
 * One level of the page tree. The caller sets the indent through `className`, so the spine the
 * connectors hang from lands under the parent row's icon — the space's dot for root pages, the
 * chevron for a page's children.
 */
export function WikiPageTree({ spaceId, pages, activePageId, className }: WikiPageTreeProps) {
	/** Render */
	return (
		<div className={cn("tree-branches", className)}>
			{pages.map((page) => (
				<WikiPageTreeItem
					key={page.id}
					spaceId={spaceId}
					page={page}
					activePageId={activePageId}
				/>
			))}
		</div>
	);
}
